
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/services/core/http.service';

type ViewState = 'form' | 'success' | 'error';

@Component({
  selector: 'app-delete-account',
  standalone: true,
  imports: [ReactiveFormsModule, MatProgressSpinner],
  templateUrl: './delete-account.component.html',
  styleUrl: './delete-account.component.scss'
})
export class DeleteAccountComponent {
  private route = inject(ActivatedRoute);
  private httpService = inject(HttpService);
  viewState: ViewState = 'form';
  myOrigin = window.location.origin;
  languageJSON: any;

  loading = false;
  showPassword = false;
  showPasswordConfirmation = false;

  token = '';

  form = new FormGroup({
    delete: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern(/^delete$/)],
    })

  });

  ngOnInit(): void {
    let lang = "";
    this.route.queryParamMap
      .subscribe((map) => {
        const token = map.get('deletetoken');
        lang = map.get('lang') ?? 'en';
        this.token = token || '';
      });

    if (!this.token) {
      this.viewState = 'error';
    }

    this.httpService.getLanguageJSON(lang).subscribe((languageJSON) => {
      this.languageJSON = languageJSON;
      document.getElementById("loading-screen")?.remove();
    });
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  togglePasswordConfirmation(): void {
    this.showPasswordConfirmation = !this.showPasswordConfirmation;
  }

  onSubmit(): void {
    if (this.loading || this.form.invalid) return;

    this.loading = true;

    this.httpService.deleteUserConfirm(this.token).subscribe({
      next: () => {
        this.viewState = 'success';
        this.loading = false;
      },
      error: (error) => {
        this.viewState = 'error';
        this.loading = false;
      }
    });
  }
}
